"use client";

import Script from "next/script";
import { useSyncExternalStore } from "react";

// Skrypty third-party ładowane TYLKO na hoście produkcyjnym.
// W starym index.html host-check miał tylko GTM; pozostałe (Pixel, CookieYes,
// Thulium, Landingi) ładowały się wszędzie. Zgodnie z zatwierdzonym planem
// bramkujemy WSZYSTKIE hostem, by nie strzelać pikselami/czatem na dev/preview.
const PROD_HOST = process.env.NEXT_PUBLIC_URL;

// useSyncExternalStore: snapshot serwera = false (brak window), snapshot klienta
// = host-check. Brak mismatchu hydracji i brak setState-w-efekcie.
const emptySubscribe = () => () => {};

export function Analytics() {
  const enabled = useSyncExternalStore(
    emptySubscribe,
    () => window.location.hostname === PROD_HOST,
    () => false,
  );

  if (!enabled) return null;

  return (
    <>
      {/* Google Tag Manager (GTM-K6X3R245) */}
      <Script id="gtm" strategy="afterInteractive">
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-K6X3R245');`}
      </Script>

      {/* Meta Pixel (348644492205860) */}
      <Script id="fb-pixel" strategy="afterInteractive">
        {`!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','348644492205860');fbq('track','PageView');`}
      </Script>

      {/* CookieYes — baner zgód */}
      <Script
        id="cookieyes"
        src="https://cdn-cookieyes.com/client_data/d87e98707e2288771bcb13f1/script.js"
        strategy="afterInteractive"
      />

      {/* Thulium — widget czatu */}
      <Script
        id="thulium-chat"
        src="https://cdn.thulium.com/apps/chat-widget/chat-loader.js?hash=salut-hola-c4f571b6-1690-480e-bdda-00a8352106bd"
        strategy="afterInteractive"
      />

      {/* Landingi — popupy */}
      <Script
        id="landingi-popups"
        src="https://popups.landingi.com/api/v3/website/install-code?apikey=4ce4ff88-71e0-4a37-8cc8-19d15187fa60"
        strategy="afterInteractive"
      />
    </>
  );
}
